import firebase from 'firebase/app';
import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireStorage } from 'angularfire2/storage';

@Injectable()

export class SdfFormService {
    public addiApplicant: any;
    constructor(
        public db: AngularFirestore,
        public afAuth:AngularFireAuth,
        private storage: AngularFireStorage
    ) { 
        this.addiApplicant = [];
    }

    signupUser(newEmail: string, newPassword: string): Promise<any> {
        return this.afAuth.auth.createUserWithEmailAndPassword(newEmail, newPassword);
    }

    addAndUpdateSDF(request){
        let thiss = this;
        const sdfForm = this.db.collection('/SDF_form');
        if(request.contact_uid == "" || request.contact_uid == null || request.contact_uid == undefined){
            let password = thiss.stringGen(10);
            let timestamp = new Date().getTime();
            firebase.auth().createUserWithEmailAndPassword(request.userData.email, password).then(function(response) {
                let new_uid = response.user.uid;
                sdfForm.doc(new_uid+'_'+timestamp).set({
                    id: new_uid+'_'+timestamp,
                    uid: new_uid
                }).then(function(response) {
                    thiss.createUserDataInUserDoc(request, new_uid, timestamp);    
                })
                .catch(err => {
                    console.log('err', err)
                });
            }).catch(function(error) {
                
                var errorCode = error.code;
                var errorMessage = error.message;
                if (errorCode == 'auth/weak-password') {
                    console.log('The password is too weak.');
                } else {
                    console.log(errorMessage);
                }
                console.log(error);
            });
        }else{
            if(request.userData.addAnotherApplicantItem.length > 0){
                Object.keys(request.userData.addAnotherApplicantItem).forEach(function(key, value) {
                    let datas = request.userData.addAnotherApplicantItem[key];
                    thiss.createUser(datas);
                });
            }
        }
    }

    UpdateSDFForm(request, postData){
        let thiss = this;
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){
        }else{
            if(request.step == 1){
                thiss.updateFirstStepData(request, postData);
            }else if(request.step == 2){
                thiss.updateSecondStepData(request);
                thiss.updateFirstStepData(request, postData);
            }else if(request.step == 3){
                thiss.updateThirdStepData(request);
                thiss.updateFirstStepData(request, postData);
            }else if(request.step == 4){
                thiss.updateFourthStepData(request);
                thiss.updateFirstStepData(request, postData);
            }else if(request.step == 5){
                thiss.updateFifthStepData(request);
                thiss.updateFirstStepData(request, postData);
            }
        }
    }

    stringGen(len) {
        var text = "";
        var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < len; i++)
          text += charset.charAt(Math.floor(Math.random() * charset.length));
        return text;
    }

    updateFirstStepData(request, postData){
        let thiss = this;
        $.getJSON('http://www.geoplugin.net/json.gp', function(data) {
            const timestamp = new Date().getTime();
            const docRef1 = thiss.db.collection('/user_history');
            if(postData.newASFCreating == 1 && request.step == 1){
                docRef1.doc('UH_'+timestamp).set({
                    ip_address: data.geoplugin_request,
                    SDF_form: request.document_id,
                    status: 1,
                    created_date: timestamp,
                    document_id: 'UH_'+timestamp,
                    contact_uid: request.primary_uid[0].primary_uid,
                    deleted: 0,
                    contact_type: 'Primary Contact',
                    created_uid: postData.uid,
                    uid: postData.uid
                });
            }else{
                let applicant_details = '';
                let income_details = '';
                let asset_details = '';
                let liability_details = '';
                let realEstate_details = '';
                if(request.step == 1){
                    if(postData.applicant_details.length == 0){
                        return false;
                    }
                    applicant_details = postData.applicant_details;
                }else if(request.step == 2){
                    if(postData.applicant_details.length == 0){
                        return false;
                    }
                    applicant_details = postData.applicant_details;
                }else if(request.step == 3){
                    if(postData.applicant_details.length == 0 && postData.income_details.length == 0){
                        return false;
                    }
                    applicant_details = postData.applicant_details;
                    income_details = postData.income_details;
                }else if(request.step == 4){
                    if(postData.asset_details.length == 0 && postData.asset_details.length == 0){
                        return false;
                    }
                    asset_details = postData.asset_details;
                    liability_details = postData.liability_details;
                }else if(request.step == 5){
                    if(postData.realEstate_details.length == 0){
                        return false;
                    }
                    realEstate_details = postData.realEstate_details;
                }
                docRef1.doc('UH_'+timestamp).set({
                    ip_address: data.geoplugin_request,
                    SDF_form: postData.document_id,
                    status: 2,
                    created_date: timestamp,
                    document_id: 'UH_'+timestamp,
                    contact_uid: (request.primary_uid[0].primary_uid == undefined) ? request.primary_uid : request.primary_uid[0].primary_uid,
                    deleted: 0,
                    contact_type: 'Primary Contact',
                    created_uid: postData.uid,
                    applicant_details: applicant_details,
                    income_details: income_details,
                    asset_details: asset_details,
                    liability_details: liability_details,
                    realEstate_details: realEstate_details,
                    uid: postData.uid
                });
            }
        });
        // if(request.secondary_uid != undefined){
        //     const docRef = this.db.collection('/SDF_form');
        //     docRef.doc(request.document_id).update({
        //         secondary_uid: request.secondary_uid
        //     });
        // }
    }

    updateSecondStepData(request){
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
            console.log('requestrequest', request);
            const docRef = this.db.collection('/users_data');
            docRef.doc(request.document_id).update({
                accessGrantedFromUser: 0
            });

            const docRef1 = this.db.collection('/users');
            docRef1.doc(request.primary_uid).update({
                gender : request.userData.gender,
                current_marital_status : request.userData.current_marital_status,
                do_you_have_children : request.userData.do_you_have_children,
                how_many_children : (request.userData.how_many_children == null) ? 0 : request.userData.how_many_children,
                first_child_age : (request.userData.first_child_age == null) ? 0 : request.userData.first_child_age,
                second_child_age : (request.userData.second_child_age == null) ? 0 : request.userData.second_child_age,
                third_child_age : (request.userData.third_child_age == null) ? 0 : request.userData.third_child_age,
                fourth_child_age : (request.userData.fourth_child_age == null) ? 0 : request.userData.fourth_child_age,
                fifth_child_age : (request.userData.fifth_child_age == null) ? 0 : request.userData.fifth_child_age,
                sixth_child_age : (request.userData.sixth_child_age == null) ? 0 : request.userData.sixth_child_age
            });

            /*add and update additional family data*/
            if(request.userData.addFamilyItem.length > 0){
                for(let i = 0; i < request.userData.addFamilyItem.length; i++){
                    this.addUpdateAddtionalFamily(request.userData.addFamilyItem[i], request.secondary_uid[i], request.document_id);
                }
            }
        }
    }

    updateThirdStepData(request){
        console.log('requestrequestrequest',request )
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
            const users_data = this.db.collection('/users_data');
            users_data.doc(request.document_id).update({
                accessGrantedFromUser: 0
            });
            const thiss = this;
            const docRef = this.db.collection('/employment');

            this.getSingleDocDataByID(request.primary_uid, 'employment').subscribe((employement_data)=>{
                if(employement_data.length > 0){
                    docRef.doc(employement_data[0].document_id).update({
                        abn_acn : (request.userData.abn_acn == null) ? '' : request.userData.abn_acn,
                        business_name : (request.userData.business_name == null) ? '' : request.userData.business_name,
                        currentlyEmployment : (request.userData.currentlyEmployment == null) ? '' : request.userData.currentlyEmployment,
                        employementType : (request.userData.employementType == null) ? '' : request.userData.employementType,
                        expectFindWork : (request.userData.expectFindWork == null) ? '' : request.userData.expectFindWork,
                        nature_of_business : (request.userData.nature_of_business == null) ? '': request.userData.nature_of_business,
                        statusyourEmployment : (request.userData.statusyourEmployment == null) ? '' : request.userData.statusyourEmployment,
                        type_of_entity : (request.userData.type_of_entity == null || request.userData.type_of_entity == undefined) ? '' : request.userData.type_of_entity,
                        your_occupation : (request.userData.your_occupation == null) ? '' : request.userData.your_occupation,
                        start_date : (request.userData.start_date == null) ? '' : request.userData.start_date,
                        primaryEmployment: request.userData.addPrimaryEmploymentItem
                    });
                }else{
                    docRef.doc(request.primary_uid).set({
                        abn_acn : (request.userData.abn_acn == null) ? '' : request.userData.abn_acn,
                        business_name : (request.userData.business_name == null) ? '' : request.userData.business_name,
                        currentlyEmployment : (request.userData.currentlyEmployment == null) ? '' : request.userData.currentlyEmployment,
                        employementType : (request.userData.employementType == null) ? '' : request.userData.employementType,
                        expectFindWork : (request.userData.expectFindWork == null) ? '' : request.userData.expectFindWork,
                        nature_of_business : (request.userData.nature_of_business == null) ? '': request.userData.nature_of_business,
                        statusyourEmployment : (request.userData.statusyourEmployment == null) ? '' : request.userData.statusyourEmployment,
                        type_of_entity : (request.userData.type_of_entity == null || request.userData.type_of_entity == undefined) ? '' : request.userData.type_of_entity,
                        your_occupation : (request.userData.your_occupation == null) ? '' : request.userData.your_occupation,
                        start_date : (request.userData.start_date == null) ? '' : request.userData.start_date,
                        primaryEmployment: request.userData.addPrimaryEmploymentItem,
                        uid: request.primary_uid,
                        deleted: 0,
                        SDF_form: request.document_id,
                        document_id: request.document_id
                    });
                }
            });

            // this.getSingleDocData(request.document_id, 'employment').subscribe((employement_data)=>{
            //     if(employement_data.length > 0){
            //         docRef.doc(employement_data[0].document_id).update({
            //             abn_acn : (request.userData.abn_acn == null) ? '' : request.userData.abn_acn,
            //             business_name : (request.userData.business_name == null) ? '' : request.userData.business_name,
            //             currentlyEmployment : (request.userData.currentlyEmployment == null) ? '' : request.userData.currentlyEmployment,
            //             employementType : (request.userData.employementType == null) ? '' : request.userData.employementType,
            //             expectFindWork : (request.userData.expectFindWork == null) ? '' : request.userData.expectFindWork,
            //             nature_of_business : (request.userData.nature_of_business == null) ? '': request.userData.nature_of_business,
            //             statusyourEmployment : (request.userData.statusyourEmployment == null) ? '' : request.userData.statusyourEmployment,
            //             type_of_entity : (request.userData.type_of_entity == null || request.userData.type_of_entity == undefined) ? '' : request.userData.type_of_entity,
            //             your_occupation : (request.userData.your_occupation == null) ? '' : request.userData.your_occupation,
            //             start_date : (request.userData.start_date == null) ? '' : request.userData.start_date,
            //             primaryEmployment: request.userData.addPrimaryEmploymentItem
            //         });
            //     }else{
            //         docRef.doc(request.document_id).set({
            //             abn_acn : (request.userData.abn_acn == null) ? '' : request.userData.abn_acn,
            //             business_name : (request.userData.business_name == null) ? '' : request.userData.business_name,
            //             currentlyEmployment : (request.userData.currentlyEmployment == null) ? '' : request.userData.currentlyEmployment,
            //             employementType : (request.userData.employementType == null) ? '' : request.userData.employementType,
            //             expectFindWork : (request.userData.expectFindWork == null) ? '' : request.userData.expectFindWork,
            //             nature_of_business : (request.userData.nature_of_business == null) ? '': request.userData.nature_of_business,
            //             statusyourEmployment : (request.userData.statusyourEmployment == null) ? '' : request.userData.statusyourEmployment,
            //             type_of_entity : (request.userData.type_of_entity == null || request.userData.type_of_entity == undefined) ? '' : request.userData.type_of_entity,
            //             your_occupation : (request.userData.your_occupation == null) ? '' : request.userData.your_occupation,
            //             start_date : (request.userData.start_date == null) ? '' : request.userData.start_date,
            //             primaryEmployment: request.userData.addPrimaryEmploymentItem,
            //             uid: request.primary_uid,
            //             deleted: 0,
            //             SDF_form: request.document_id,
            //             document_id: request.document_id
            //         });
            //     }
            // });


            /*add and update primary incomes*/
            if(request.incomeForm.itemRows.length > 0){
                for(let i = 0; i < request.incomeForm.itemRows.length; i++){
                    thiss.addUpdateIncomes(request.incomeForm.itemRows[i], request.primary_uid, request.document_id);
                }
            }
            /*add and update additional employments*/
            if(request.userData.addEmploymentItem.length > 0){
                for(let i = 0; i < request.userData.addEmploymentItem.length; i++){
                    thiss.addUpdateAddtionalEmployement(request.userData.addEmploymentItem[i], request.secondary_uid[i], request.document_id);
                }
            }
            /*add and update secondary incomes*/
            if(request.incomeForm.addApplicantIncomeItem.length > 0){
                for(let i = 0; i < request.incomeForm.addApplicantIncomeItem.length; i++){
                    if(request.incomeForm.addApplicantIncomeItem[i].itemRows.length > 0){
                        for(let j = 0; j < request.incomeForm.addApplicantIncomeItem[i].itemRows.length; j++){
                            thiss.addUpdateIncomes(request.incomeForm.addApplicantIncomeItem[i].itemRows[j], request.secondary_uid[i].secondary_uid, request.document_id);
                        }
                    }
                }
            }
            
        }
    }

    updateFourthStepData(request){
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
            const users_data = this.db.collection('/users_data');
            users_data.doc(request.document_id).update({
                accessGrantedFromUser: 0
            });
            const thiss = this;
            if(request.assetsData.itemRowsAssets.length > 0){
                for(let i = 0; i < request.assetsData.itemRowsAssets.length; i++){
                    thiss.addUpdateAssets(request.assetsData.itemRowsAssets[i], request.primary_uid, request.document_id, i);
                    // if(request.secondary_uid == undefined || request.secondary_uid == "" || request.secondary_uid == null){

                    // }else if(request.secondary_uid.length > 0){
                    //     for(let k = 0; k < request.secondary_uid.length; k++){
                    //         thiss.addUpdateAssets(request.assetsData.itemRowsAssets[i], request.secondary_uid[k].secondary_uid, request.document_id);
                    //     }
                    // }
                }
            }
            if(request.liabilitiesData.itemRowsLiabilities.length > 0){
                for(let j = 0; j < request.liabilitiesData.itemRowsLiabilities.length; j++){
                    thiss.addUpdateLiabilities(request.liabilitiesData.itemRowsLiabilities[j], request.document_id, request.contact_uid, request.primary_uid);
                }
            }            
        }
    }

    updateFifthStepData(request){
        console.log('request', request);
        if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
            const users_data = this.db.collection('/users_data');
            users_data.doc(request.document_id).update({
                accessGrantedFromUser: 0
            });
            const thiss = this;
            if(request.realEstateForm.itemRowsRealEstates.length > 0){
                for(let i = 0; i < request.realEstateForm.itemRowsRealEstates.length; i++){
                    thiss.addUpdateRealAssets(request.realEstateForm.itemRowsRealEstates[i], request.primary_uid, request.document_id, i);
                }
            }           
        }
    }


    addUpdateAddtionalFamily(requestData, secondary_uid, SDF_form){
        const docRef = this.db.collection('/users_data');
        docRef.doc(secondary_uid.document_id).update({
            accessGrantedFromUser: 0
        });
        const docRef1 = this.db.collection('/users');
        docRef1.doc(secondary_uid.secondary_uid).update({
            gender : requestData.gender,
            current_marital_status : requestData.current_marital_status,
            do_you_have_children : requestData.do_you_have_children,
            how_many_children : (requestData.how_many_children == null) ? 0 : requestData.how_many_children,
            first_child_age : (requestData.first_child_age == null) ? 0 : requestData.first_child_age,
            second_child_age : (requestData.second_child_age == null) ? 0 : requestData.second_child_age,
            third_child_age : (requestData.third_child_age == null) ? 0 : requestData.third_child_age,
            fourth_child_age : (requestData.fourth_child_age == null) ? 0 : requestData.fourth_child_age,
            fifth_child_age : (requestData.fifth_child_age == null) ? 0 : requestData.fifth_child_age,
            sixth_child_age : (requestData.sixth_child_age == null) ? 0 : requestData.sixth_child_age
        });
                
    }

    addUpdateAddtionalEmployement(requestData, secondary_uid, SDF_form){
        const docRef = this.db.collection('/employment');
        if(requestData.document_id == "" || requestData.document_id == null || requestData.document_id == undefined){
            docRef.doc(secondary_uid.secondary_uid).set({
                abn_acn : (requestData.abn_acn == null) ? '' : requestData.abn_acn,
                business_name : (requestData.business_name == null) ? '' : requestData.business_name,
                currentlyEmployment : (requestData.currentlyEmployment == null) ? '' : requestData.currentlyEmployment,
                employementType : (requestData.employementType == null) ? '' : requestData.employementType,
                expectFindWork : (requestData.expectFindWork == null) ? '' : requestData.expectFindWork,
                nature_of_business : (requestData.nature_of_business == null) ? '': requestData.nature_of_business,
                statusyourEmployment : (requestData.statusyourEmployment == null) ? '' : requestData.statusyourEmployment,
                type_of_entity : (requestData.type_of_entity == null) ? '' : requestData.type_of_entity,
                your_occupation : (requestData.your_occupation == null) ? '' : requestData.your_occupation,
                start_date : (requestData.start_date == null) ? '' : requestData.start_date,
                primaryEmployment: requestData.previousEmploymentItem,
                uid: secondary_uid.secondary_uid,
                document_id: secondary_uid.document_id,
                SDF_form: SDF_form,
                deleted: 0
            });
        }else{
            docRef.doc(requestData.document_id).update({
                abn_acn : (requestData.abn_acn == null) ? '' : requestData.abn_acn,
                business_name : (requestData.business_name == null) ? '' : requestData.business_name,
                currentlyEmployment : (requestData.currentlyEmployment == null) ? '' : requestData.currentlyEmployment,
                employementType : (requestData.employementType == null) ? '' : requestData.employementType,
                expectFindWork : (requestData.expectFindWork == null) ? '' : requestData.expectFindWork,
                nature_of_business : (requestData.nature_of_business == null) ? '': requestData.nature_of_business,
                statusyourEmployment : (requestData.statusyourEmployment == null) ? '' : requestData.statusyourEmployment,
                type_of_entity : (requestData.type_of_entity == null) ? '' : requestData.type_of_entity,
                your_occupation : (requestData.your_occupation == null) ? '' : requestData.your_occupation,
                start_date : (requestData.start_date == null) ? '' : requestData.start_date,
                primaryEmployment: requestData.previousEmploymentItem
            });
        }
                
    }

    addUpdateIncomes(data, uid, SDF_form_id){
        let thiss = this;
        const timestamp = new Date().getTime();
        const docRef = this.db.collection('/SDF_income');
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){
            docRef.doc(uid+'_'+timestamp).set({
                amount : (data.amount == null) ? '' : data.amount.split("$").join("").split(",").join(""),
                any_other_allowances : (data.any_other_allowances == null) ? '' : data.any_other_allowances,
                comments : (data.comments == null) ? '' : data.comments,
                date_commenced : (data.date_commenced == null) ? '' : data.date_commenced,
                frequency : (data.frequency == null) ? '' : data.frequency,
                receive_commissions_bounses : (data.receive_commissions_bounses == null) ? '' : data.receive_commissions_bounses,
                receive_moter_vehicle_allowance : (data.receive_moter_vehicle_allowance == null) ? '' : data.receive_moter_vehicle_allowance,
                receive_overtime : (data.receive_overtime == null) ? '' : data.receive_overtime,
                salary_sacrifice : (data.salary_sacrifice == null) ? '' : data.salary_sacrifice,
                sallary_payslip_0 : (data.sallary_payslip_0 == null) ? '' : data.sallary_payslip_0,
                sallary_payslip_1 : (data.sallary_payslip_1 == null) ? '' : data.sallary_payslip_1,
                sallary_payslip_2 : (data.sallary_payslip_2 == null) ? '' : data.sallary_payslip_2,
                sallary_payslip_3 : (data.sallary_payslip_3 == null) ? '' : data.sallary_payslip_3,
                sallary_payslip_4 : (data.sallary_payslip_4 == null) ? '' : data.sallary_payslip_4,
                sallary_payslip_5 : (data.sallary_payslip_5 == null) ? '' : data.sallary_payslip_5,
                sallary_payslip_name_0 : (data.sallary_payslip_0 == null) ? '' : data.sallary_payslip_name_0,
                sallary_payslip_name_1 : (data.sallary_payslip_1 == null) ? '' : data.sallary_payslip_name_1,
                sallary_payslip_name_2 : (data.sallary_payslip_2 == null) ? '' : data.sallary_payslip_name_2,
                sallary_payslip_name_3 : (data.sallary_payslip_3 == null) ? '' : data.sallary_payslip_name_3,
                sallary_payslip_name_4 : (data.sallary_payslip_4 == null) ? '' : data.sallary_payslip_name_4,
                sallary_payslip_name_5 : (data.sallary_payslip_5 == null) ? '' : data.sallary_payslip_name_5,
                type : (data.type == null) ? '' : data.type,
                SDF_form: SDF_form_id,
                created_date: timestamp,
                uid: uid,
                deleted: 0,
                document_id: uid+'_'+timestamp
            }).then(function(response) {
                if(data.type == 'Salary'){
                    const fileraw = data.sallary_payslip;
                    const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
                    const result = thiss.SaveImageRef(filePath, fileraw);
                    const ref = result.ref;
                    ref.getDownloadURL().subscribe(a => {
                    });
                }
            }).catch(err => {
                return false;
            });
                
        }else{
            docRef.doc(data.document_id).update({
                amount : (data.amount == null) ? '' : data.amount.split("$").join("").split(",").join(""),
                any_other_allowances : (data.any_other_allowances == null) ? '' : data.any_other_allowances,
                comments : (data.comments == null) ? '' : data.comments,
                date_commenced : (data.date_commenced == null) ? '' : data.date_commenced,
                frequency : (data.frequency == null) ? '' : data.frequency,
                receive_commissions_bounses : (data.receive_commissions_bounses == null) ? '' : data.receive_commissions_bounses,
                receive_moter_vehicle_allowance : (data.receive_moter_vehicle_allowance == null) ? '' : data.receive_moter_vehicle_allowance,
                receive_overtime : (data.receive_overtime == null) ? '' : data.receive_overtime,
                salary_sacrifice : (data.salary_sacrifice == null) ? '' : data.salary_sacrifice,
                sallary_payslip_0 : (data.sallary_payslip_0 == null) ? null : data.sallary_payslip_0,
                sallary_payslip_1 : (data.sallary_payslip_1 == null) ? null : data.sallary_payslip_1,
                sallary_payslip_2 : (data.sallary_payslip_2 == null) ? null : data.sallary_payslip_2,
                sallary_payslip_3 : (data.sallary_payslip_3 == null) ? null : data.sallary_payslip_3,
                sallary_payslip_4 : (data.sallary_payslip_4 == null) ? null : data.sallary_payslip_4,
                sallary_payslip_5 : (data.sallary_payslip_5 == null) ? null : data.sallary_payslip_5,
                sallary_payslip_name_0 : (data.sallary_payslip_0 == null) ? '' : data.sallary_payslip_name_0,
                sallary_payslip_name_1 : (data.sallary_payslip_1 == null) ? '' : data.sallary_payslip_name_1,
                sallary_payslip_name_2 : (data.sallary_payslip_2 == null) ? '' : data.sallary_payslip_name_2,
                sallary_payslip_name_3 : (data.sallary_payslip_3 == null) ? '' : data.sallary_payslip_name_3,
                sallary_payslip_name_4 : (data.sallary_payslip_4 == null) ? '' : data.sallary_payslip_name_4,
                sallary_payslip_name_5 : (data.sallary_payslip_5 == null) ? '' : data.sallary_payslip_name_5,
                type : (data.type == null) ? '' : data.type
            }).then(function(response) {
                if(data.type == 'Salary'){
                    const fileraw = data.sallary_payslip;
                    const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
                    const result = thiss.SaveImageRef(filePath, fileraw);
                    const ref = result.ref;
                    ref.getDownloadURL().subscribe(a => {
                    });
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }

    SaveImageRef(filePath, file) {
        return {
          task: this.storage.upload(filePath, file), 
          ref: this.storage.ref(filePath)
        };
    }

    addUpdateAssets(data, uid, SDF_form_id, i){
        const timestamp = new Date().getTime()+i;
        const docRef = this.db.collection('/SDF_assets');
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){
            docRef.doc(uid+'_'+timestamp).set({
                account_name : (data.account_name == null) ? '' : data.account_name,
                account_no : (data.account_no == null) ? '' : data.account_no,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                bsb : (data.bsb == null) ? '' : data.bsb,
                description : (data.description == null) ? '' : data.description,
                institution : (data.institution == null) ? '' : data.institution,
                make : (data.make == null) ? '' : data.make,
                percentage_asset : (data.percentage_asset == null) ? '' : data.percentage_asset,
                percentage_asset_0 : (data.percentage_asset_0 == null) ? '' : data.percentage_asset_0,
                percentage_asset_1 : (data.percentage_asset_1 == null) ? '' : data.percentage_asset_1,
                percentage_asset_2 : (data.percentage_asset_2 == null) ? '' : data.percentage_asset_2,
                percentage_asset_3 : (data.percentage_asset_3 == null) ? '' : data.percentage_asset_3,
                percentage_asset_4 : (data.percentage_asset_4 == null) ? '' : data.percentage_asset_4,
                type : (data.type == null) ? '' : data.type,
                value_basis : (data.value_basis == null) ? 0 : data.value_basis,
                year : (data.year == null) ? '' : data.year,
                SDF_form: SDF_form_id,
                created_date: timestamp,
                uid: uid,
                deleted: 0,
                document_id: uid+'_'+timestamp
            })
        }else{
            docRef.doc(data.document_id).update({
                account_name : (data.account_name == null) ? '' : data.account_name,
                account_no : (data.account_no == null) ? '' : data.account_no,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                bsb : (data.bsb == null) ? '' : data.bsb,
                description : (data.description == null) ? '' : data.description,
                institution : (data.institution == null) ? '' : data.institution,
                make : (data.make == null) ? '' : data.make,
                percentage_asset : (data.percentage_asset == null) ? '' : data.percentage_asset,
                percentage_asset_0 : (data.percentage_asset_0 == null) ? '' : data.percentage_asset_0,
                percentage_asset_1 : (data.percentage_asset_1 == null) ? '' : data.percentage_asset_1,
                percentage_asset_2 : (data.percentage_asset_2 == null) ? '' : data.percentage_asset_2,
                percentage_asset_3 : (data.percentage_asset_3 == null) ? '' : data.percentage_asset_3,
                percentage_asset_4 : (data.percentage_asset_4 == null) ? '' : data.percentage_asset_4,
                type : (data.type == null) ? '' : data.type,
                value_basis : (data.value_basis == null) ? 0 : data.value_basis,
                year : (data.year == null) ? '' : data.year
            })
        }
    }

    addUpdateLiabilities(data, SDF_form_id, contact_uid, primary_uid){
        let owner = data.owner;
        if(data.owner == "" || data.owner == null || data.owner == undefined){
            if(primary_uid == undefined || primary_uid == null || primary_uid == ""){
                owner = contact_uid;
            }else{
                owner = primary_uid;
            }
        }
        const timestamp = new Date().getTime();
        const docRef = this.db.collection('/SDF_liabilities');
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){
            docRef.doc(data.owner+'_'+timestamp).set({
                account_name : (data.account_name == null) ? '' : data.account_name,
                account_no : (data.account_no == null) ? '' : data.account_no,
                bsb : (data.bsb == null) ? '' : data.bsb,
                clearing_from_this_loan : (data.clearing_from_this_loan == null) ? '' : data.clearing_from_this_loan,
                credit_cart_type : (data.credit_cart_type == null) ? '' : data.credit_cart_type,
                current_balance : (data.current_balance == null) ? 0 : data.current_balance.split("$").join("").split(",").join(""),
                description : (data.description == null) ? '' : data.description,
                institution : (data.institution == null) ? '' : data.institution,
                liability_type : (data.liability_type == null) ? '' : data.liability_type,
                limit : (data.limit == null) ? 0 : data.limit.split("$").join("").split(",").join(""),
                payment_type : (data.payment_type == null) ? '' : data.payment_type,
                repayments : (data.repayments == null) ? '' : data.repayments,
                SDF_form: SDF_form_id,
                created_date: timestamp,
                uid: owner,
                deleted: 0,
                document_id: data.owner+'_'+timestamp
            })
        }else{
            docRef.doc(data.document_id).update({
                account_name : (data.account_name == null) ? '' : data.account_name,
                account_no : (data.account_no == null) ? '' : data.account_no,
                bsb : (data.bsb == null) ? '' : data.bsb,
                clearing_from_this_loan : (data.clearing_from_this_loan == null) ? '' : data.clearing_from_this_loan,
                credit_cart_type : (data.credit_cart_type == null) ? '' : data.credit_cart_type,
                current_balance : (data.current_balance == null) ? 0 : data.current_balance.split("$").join("").split(",").join(""),
                description : (data.description == null) ? '' : data.description,
                institution : (data.institution == null) ? '' : data.institution,
                liability_type : (data.liability_type == null) ? '' : data.liability_type,
                limit : (data.limit == null) ? 0 : data.limit.split("$").join("").split(",").join(""),
                payment_type : (data.payment_type == null) ? '' : data.payment_type,
                repayments : (data.repayments == null) ? '' : data.repayments,
                uid: owner
            })
        }
    }

    addUpdateRealAssets(data, uid, SDF_form_id, i){
        const thiss = this;
        const timestamp = new Date().getTime()+i;
        const docRef = this.db.collection('/SDF_realestate');
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){
            docRef.doc(uid+'_'+timestamp).set({
                address_format : (data.address_format == null) ? '' : data.address_format,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                building_name : (data.building_name == null) ? '' : data.building_name,
                city : (data.city == null) ? '' : data.city,
                country : (data.country == null) ? 0 : data.country,
                floor_number : (data.floor_number == null) ? '' : data.floor_number,
                gross_amount : (data.gross_amount == null) ? '' : data.gross_amount.split("$").join("").split(",").join(""),
                notes : (data.notes == null) ? '' : data.notes,
                ownership_title_name : (data.ownership_title_name == null) ? 0 : data.ownership_title_name,
                postcode : (data.postcode == null) ? '' : data.postcode,
                primary_percentage_asset : (data.primary_percentage_asset == null) ? '' : data.primary_percentage_asset,
                secondary_percentage_asset_0 : (data.secondary_percentage_asset_0 == null) ? '' : data.secondary_percentage_asset_0,
                secondary_percentage_asset_1 : (data.secondary_percentage_asset_1 == null) ? '' : data.secondary_percentage_asset_1,
                secondary_percentage_asset_2 : (data.secondary_percentage_asset_2 == null) ? '' : data.secondary_percentage_asset_2,
                secondary_percentage_asset_3 : (data.secondary_percentage_asset_3 == null) ? '' : data.secondary_percentage_asset_3,
                secondary_percentage_asset_4 : (data.secondary_percentage_asset_4 == null) ? '' : data.secondary_percentage_asset_4,
                state : (data.state == null) ? '' : data.state,
                street_name : (data.street_name == null) ? '' : data.street_name,
                street_number : (data.street_number == null) ? '' : data.street_number,
                street_type : (data.street_type == null) ? '' : data.street_type,
                unit_number : (data.unit_number == null) ? '' : data.unit_number,
                value_basis : (data.value_basis == null) ? '' : data.value_basis,
                split: data.itemRowsMortgageSplits,
                SDF_form: SDF_form_id,
                created_date: timestamp,
                uid: uid,
                deleted: 0,
                document_id: uid+'_'+timestamp
            }).then(function(response) {
                thiss.createSplitInRealEstate(data, uid, timestamp);
            })
            .catch(err => {
                return false;
            });
        }else{
            docRef.doc(data.document_id).update({
                address_format : (data.address_format == null) ? '' : data.address_format,
                asset_type : (data.asset_type == null) ? '' : data.asset_type,
                asset_value : (data.asset_value == null) ? '' : data.asset_value.split("$").join("").split(",").join(""),
                building_name : (data.building_name == null) ? '' : data.building_name,
                city : (data.city == null) ? '' : data.city,
                country : (data.country == null) ? 0 : data.country,
                floor_number : (data.floor_number == null) ? '' : data.floor_number,
                gross_amount : (data.gross_amount == null) ? '' : data.gross_amount.split("$").join("").split(",").join(""),
                notes : (data.notes == null) ? '' : data.notes,
                ownership_title_name : (data.ownership_title_name == null) ? 0 : data.ownership_title_name,
                postcode : (data.postcode == null) ? '' : data.postcode,
                primary_percentage_asset : (data.primary_percentage_asset == null) ? '' : data.primary_percentage_asset,
                secondary_percentage_asset_0 : (data.secondary_percentage_asset_0 == null) ? '' : data.secondary_percentage_asset_0,
                secondary_percentage_asset_1 : (data.secondary_percentage_asset_1 == null) ? '' : data.secondary_percentage_asset_1,
                secondary_percentage_asset_2 : (data.secondary_percentage_asset_2 == null) ? '' : data.secondary_percentage_asset_2,
                secondary_percentage_asset_3 : (data.secondary_percentage_asset_3 == null) ? '' : data.secondary_percentage_asset_3,
                secondary_percentage_asset_4 : (data.secondary_percentage_asset_4 == null) ? '' : data.secondary_percentage_asset_4,
                state : (data.state == null) ? '' : data.state,
                street_name : (data.street_name == null) ? '' : data.street_name,
                street_number : (data.street_number == null) ? '' : data.street_number,
                street_type : (data.street_type == null) ? '' : data.street_type,
                unit_number : (data.unit_number == null) ? '' : data.unit_number,
                value_basis : (data.value_basis == null) ? '' : data.value_basis,
                split: data.itemRowsMortgageSplits
            }).then(function(response) {
                thiss.createSplitInRealEstate(data, uid, timestamp);
            })
            .catch(err => {
                return false;
            });
        }
    }

    createSplitInRealEstate(data, uid, timestamp){
        console.log('datatatat', data);
        let doc_idd = uid+'_'+timestamp;
        if(data.document_id == "" || data.document_id == null || data.document_id == undefined){}else{
            doc_idd = data.document_id;
        }
        console.log('doc_idd', doc_idd);
        const docRef = this.db.collection('SDF_realestate').doc(doc_idd).collection('mortgage_splits');
        for(let l = 0; l < data.itemRowsMortgageSplits.length; l++){
            console.log('datatatat11', data.itemRowsMortgageSplits[l]);
            const randN1 = new Date().getTime();
            if(data.itemRowsMortgageSplits[l].document_id == "" || data.itemRowsMortgageSplits[l].document_id == null || data.itemRowsMortgageSplits[l].document_id == undefined){
                data.itemRowsMortgageSplits[l].document_id = 'msd_'+l+'_'+randN1;
                data.itemRowsMortgageSplits[l].created_date = randN1;
                docRef.doc('msd_'+l+'_'+randN1).set(data.itemRowsMortgageSplits[l]);  
            }else{
                data.itemRowsMortgageSplits[l].created_date = randN1;
                docRef.doc(data.itemRowsMortgageSplits[l].document_id).update(data.itemRowsMortgageSplits[l]);  
            }
            
        }
    }

    createUserDataInUserDoc(request, new_uid, timestamp){
        let thiss = this;
        const docRef = this.db.collection('/users');
        docRef.doc(new_uid+'_'+timestamp).set({
            firstname : request.userData.firstname,
            lastname : request.userData.lastname,
            middlename : request.userData.middlename,
            mobile_phone : request.userData.mobile_phone,
            email : request.userData.email,
            date_of_birth : request.userData.date_of_birth,
            primayr_goal_intention : request.userData.primayr_goal_intention,
            address_type : request.userData.address_type,
            address_format : request.userData.address_format,
            floor_number : request.userData.floor_number,
            unit_number : request.userData.unit_number,
            building_name : request.userData.building_name,
            street_number : request.userData.street_number,
            street_name : request.userData.street_name,
            street_type : request.userData.street_type,
            poboxlabel : request.userData.poboxlabel,
            city : request.userData.city,
            state : request.userData.state,
            postcode : request.userData.postcode,
            country : request.userData.country,
            housing_situation : request.userData.housing_situation,
            move_in_date : request.userData.move_in_date,
            accessGrantedFromUser: 0,
            requested_documents_status : 0,
            document_id: new_uid+'_'+timestamp,
            uid : new_uid,
            created_date: timestamp,
            reference_broker: request.userData.reference_broker,
            roles : {
                contact : true
            },
            contact_type: 'Primary Contact',
            deleted: 0,
            SDF_form_document_id: new_uid+'_'+timestamp,
            PreviousAddress: request.userData.addPreviousAddressItem
        }).then(function(response) {
            if(request.userData.addAnotherApplicantItem.length > 0){
                Object.keys(request.userData.addAnotherApplicantItem).forEach(function(key) {
                    let datas = request.userData.addAnotherApplicantItem[key];
                    thiss.createUser(datas);
                });
            }
        })
        .catch(err => {
            return 'failure';
        });

        
    }

    createUser(datas){
        let password = this.stringGen(10);
        let email = datas.secondary_email;
        firebase.auth().createUserWithEmailAndPassword(email, password).then(function(response) {
            this.addiApplicant.push(response.user.uid);
        }).catch(function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            if (errorCode == 'auth/weak-password') {
            } else {
                console.log(errorMessage);
            }
        });
    }

    getSingleDocData(doc_id, collectionName){
        return this.db.collection<any>( collectionName , ref => ref.where('document_id','==',doc_id )).valueChanges ();
    }

    getSingleDocDataByID(uid, collectionName){
        return this.db.collection<any>( collectionName , ref => ref.where('uid','==',uid )).valueChanges ();
    }

    getUsersData(doc_id, collectionName, fieldName){
        return this.db.collection<any>( collectionName , ref => ref.where(fieldName,'==',doc_id )).valueChanges ();
    }

    getData(doc_id, SDF_form_document_id, collectionName, fieldName){
        return this.db.collection<any>( collectionName , ref => ref.where(fieldName,'==',doc_id).where('SDF_form','==',SDF_form_document_id)).valueChanges ();
    }

    deleteAdditionalApplicant(postData){
        let thiss = this;
        const docRef1 = this.db.collection('/users');
        const docRef2 = this.db.collection('/users_data');
        const docRef3 = this.db.collection('/employment');
        const docRef4 = this.db.collection('/SDF_income');
        const docRef5 = this.db.collection('/SDF_liabilities');
        docRef1.doc(postData.uid).update({
            deleted: 1
        }).then(function(response) {
            thiss.getUsersData(postData.uid, 'users_data', 'uid').subscribe((users_data)=>{
                if(users_data.length > 0){
                    Object.keys(users_data).forEach(function(key) {
                        docRef2.doc(users_data[key].document_id).update({
                            deleted: 1,
                            //SDF_form_document_id: ""
                        }).then(function(response) {
                            thiss.getUsersData(postData.uid, 'employment', 'uid').subscribe((employment)=>{
                                if(employment.length > 0){
                                    Object.keys(employment).forEach(function(key) {
                                        docRef3.doc(employment[key].document_id).update({
                                            deleted: 1
                                        });
                                    });
                                }
                            });
                            thiss.getData(postData.uid, postData.SDF_form_document_id, 'SDF_income', 'uid').subscribe((income)=>{
                                if(income.length > 0){
                                    Object.keys(income).forEach(function(key) {
                                        docRef4.doc(income[key].document_id).update({
                                            deleted: 1
                                        });
                                    });
                                }
                            });
                            thiss.getData(postData.uid, postData.SDF_form_document_id, 'SDF_liabilities', 'uid').subscribe((liabilities)=>{
                                if(liabilities.length > 0){
                                    Object.keys(liabilities).forEach(function(key) {
                                        docRef5.doc(liabilities[key].document_id).update({
                                            deleted: 1
                                        });
                                    });
                                }
                            });
                        })
                        .catch(err => {
                            console.log('err', err)
                        });
                    });
                }
            });
        })
        .catch(err => {
            console.log('err', err)
        });
    }

    deleteDocument(postData){
        const docRef = firebase.firestore().collection('/'+postData.collection);
        if(postData.parent_document_id == undefined){
            return docRef.doc(postData.document_id).update({
                deleted : postData.deleted,
                deleted_date : postData.deleted_date
            });
        }else{
            return docRef.doc(postData.parent_document_id).collection('mortgage_splits').doc(postData.document_id).update({
                deleted : postData.deleted,
                deleted_date : postData.deleted_date
            });
        }
    }

    getAllUserDate(){
        return new Promise((resolve, reject) => {
          const events = firebase.firestore().collection('users')
          events.get().then((querySnapshot) => {
              const tempDoc = []
              querySnapshot.forEach((doc) => {
                tempDoc.push({ id: doc.id, ...doc.data() })
                // if(doc.data().uid != undefined){
                //     firebase.firestore().collection("users_data").where("uid", "==", doc.data().uid).get()
                //       .then(function(querySnapshot2) {
                //         querySnapshot2.forEach(function(secdoc) {
                //             if(secdoc.data() != undefined){
                //                 if(secdoc.data().date_of_birth != undefined){
                //                     tempDoc.push({ 'firstname': doc.data().firstname, 'middlename': doc.data().middlename, 'lastname': doc.data().lastname, 'email': doc.data().email, 'mobile_phone': doc.data().mobile_phone, 'date_of_birth': secdoc.data().date_of_birth })
                //                 }else{
                //                     tempDoc.push({ 'firstname': doc.data().firstname, 'middlename': doc.data().middlename, 'lastname': doc.data().lastname, 'email': doc.data().email, 'mobile_phone': doc.data().mobile_phone })    
                //                 }
                //             }else{
                //                 tempDoc.push({ 'firstname': doc.data().firstname, 'middlename': doc.data().middlename, 'lastname': doc.data().lastname, 'email': doc.data().email, 'mobile_phone': doc.data().mobile_phone })
                //             }
                //         })
                //         if(querySnapshot2.empty){
                //             tempDoc.push({ 'firstname': doc.data().firstname, 'middlename': doc.data().middlename, 'lastname': doc.data().lastname, 'email': doc.data().email, 'mobile_phone': doc.data().mobile_phone })
                //         }
                //     })
                // }else{
                //     tempDoc.push({ 'firstname': doc.data().firstname, 'middlename': doc.data().middlename, 'lastname': doc.data().lastname, 'email': doc.data().email, 'mobile_phone': doc.data().mobile_phone })
                // }
              })
              resolve(tempDoc);
          }, (err) => {
            reject(err);
          })
        });
  
    }

    get_second_user_data(SDF_form_document_id){
        return new Promise((resolve, reject) => {
          const events = firebase.firestore().collection('users_data').where('created_date','>',0 ).where('contact_type','==','Secondary Contact').where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','==',0 ).orderBy('created_date', 'asc')
          events.get().then((querySnapshot) => {
              const tempDoc = []
              querySnapshot.forEach((doc) => {
                tempDoc.push({ id: doc.id, ...doc.data() })
              })
              resolve(tempDoc);
          }, (err) => {
            reject(err);
          })
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/sdf-form-service.ts